import utils from '../../../utils/utils';
import { getIsLoggedInKambi, getKambiConfig } from '../utils/utils';

const reloginKambi = () => {
  window?.KambiWidget?.ready?.then(async wapi => {
    try {
      const kambiConfig = await getKambiConfig(true);

      if (!kambiConfig) {
        console.error('Kambi config not found');
        return;
      }

      kambiConfig.punterId = kambiConfig.playerId;
      delete kambiConfig.playerId;

      wapi.request(wapi.LOGIN, kambiConfig);
    } catch (error) {
      console.error('Error al reloguear en Kambi:', error);
    }
  });
};

(function(global) {
  console.log('betting-client-settings');
  //---------------------------------------------------------------------
  //
  //  Public methods
  //
  //---------------------------------------------------------------------
  /**
   * Client settings object which provides settings properties and functions
   * for which the Kambi application will integrate with.
   *
   * Notes:
   * - Unless specified, data must be returned synchronously.
   * - If multiple languages are supported, a betting-client-settings file must be
   *      created and translated for each language. The operator's index HTML
   *      page must return the correct translated settings file.
   *
   * @class CustomerSettings
   */

  var CustomerSettings = function() {
    /**
     * The URL location to redirect to when the user clicks on the
     * login button in the header. This URL can be an absolute URL or
     * a relative URL which is relative to the HTML file.
     *
     * A special case: Setting this.loginUrl = 'notification' will
     * prevent a redirect and instead the Kambi client sends a
     * notification event 'loginRequested'.
     * see https://www.kambipartner.com/techhub/api_docs/gen_doc/client_documentation/how_to_integrate_the_html5_client/catalog_of_notification_events
     *
     * @type String
     * @default undefined
     */
    this.loginUrl = '/ingresar';
    this.prioritiseClientApiLoading;
  };

  /**
   * Inform the operator to keep the logged in users session alive.
   * Called with an interval of 120 seconds as long as user interacts with the client.
   *
   * NOTE: From release 1.668.0 the client will not pass $ reference to jQuery library in function arguments
   */
  CustomerSettings.prototype.heartbeat = function() {
    getIsLoggedInKambi().then(isLoggedIn => {
      // Si el usuario no está logueado en Kambi, revisamos si el token es vigente en nuestro sitio

      if (!isLoggedIn) {
        // Revisamos si el token es vigente en nuestro sitio
        const isTokenExpired = utils.isTokenExpired(utils.getToken());
        const user = utils.getUserInfo();

        if (!isTokenExpired && user) {
          // El usuario está logueado en nuestro sitio y el token es vigente
          // Relogueamos automáticamente en Kambi
          console.log('Relogin Kambi debido a: sesión expirada');
          reloginKambi();
        }
      }
    });
  };

  /**
   * Register a callback that is called once with its own callback to be called to keep the client session alive.
   * It will register a custom interaction and in the end of the heartbeat trigger the heartbeat as like any other interaction
   *
   * @param {Function} cb Callback to trigger when interaction happens
   *
   * Example:
   * CustomerSettings.prototype.registerKeepAliveCallback(function (userInteractedWithOperator) {
   *  operatorContainerElement.addEventListerner('click', userInteractedWithOperator, false)
   * });
   */
  CustomerSettings.prototype.registerKeepAliveCallback = function(callback) {
    if (typeof callback !== 'function') {
      console.warn('[Kambi] registerKeepAliveCallback: callback debe ser una función');
      return;
    }

    // Registrar eventos de interacción del usuario fuera del widget de Kambi
    // Esto permite que las interacciones en la página principal también mantengan la sesión activa
    if (typeof window !== 'undefined' && window.document) {
      const userInteractedWithOperator = function() {
        // Cuando el usuario interactúa, llamar al callback proporcionado por Kambi
        // Esto notifica a Kambi que hubo actividad y debe mantener la sesión
        if (callback) {
          callback();
        }
      };

      // Registrar eventos comunes de interacción del usuario
      const events = ['click', 'keydown', 'scroll', 'mousemove', 'touchstart'];

      events.forEach(function(eventType) {
        window.document.addEventListener(eventType, userInteractedWithOperator, { passive: true });
      });

      console.log('[Kambi] Keep-alive callbacks registrados para mantener sesión activa');
    }
  };

  // Set the operator callbacks to the global space
  global.customerSettings = new CustomerSettings();
})(window);
